/* eslint-disable no-unused-vars */
/* eslint-disable indent */

import React, { useEffect, useState } from "react";
import { Button, Table, message } from "antd";  
import { DownloadOutlined } from "@ant-design/icons";
import "./style.scss";

import Heading from "../../../components/Heading";
import { useLocation, useNavigate } from "react-router-dom";
import API from "../../../api";
import urls from "../../../api/urls";
import { downloadReport } from "../../../utils/downloadUtils";
import { downloadIncomingLCRReport, downloadDetailedBagOrShipmentLCRReport } from "../../../utils/downloadUtils";
import { showErrorMessage } from "../../../utils";
import moment from "moment";

const DetailedInOutView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location || {};
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: false,
    showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} items`,
    pageSizeOptions: ["10", "20", "50", "100"]
  });
  const { BAG_DETAIL_VIEW, SHIPMENT_DETAIL_VIEW, BAG_DETAIL_VIEW_LCR, SHIPMENT_DETAIL_VIEW_LCR } = urls;

  console.log("location", location);
  
  useEffect(() => {
    const extractDataArray = (apiResult) => {
      if (Array.isArray(apiResult?.response)) {
        return apiResult.response;
      } else if (Array.isArray(apiResult?.response?.data)) {
        return apiResult.response.data;
      } else if (Array.isArray(apiResult?.response?.data?.list)) {
        return apiResult.response.data.list;
      } else if (Array.isArray(apiResult?.response?.response?.data)) {
        return apiResult.response.response.data;
      }
      return [];
    };

    const fetchData = async () => {
      //console.log(state?.pageFrom + "      " + state?.type + "       "+state.status);
      // if (!state?.vehicle_lcr_id || !state?.status || !state?.type) return;
      setLoading(true);
      try {
        /*const queryParams = {
          lcrNum: state.vehicle_lcr_id,
          type: state.status,
        };*/
        //console.log("datat derom..", JSON.stringify(state.data));
        let apiResult;
       // let endpoint = state.pageFrom === "InComingLCReport" || state.pageFrom === "OutGoingLCReport" ? state.type === "Bag" ? BAG_DETAIL_VIEW_LCR : SHIPMENT_DETAIL_VIEW_LCR : state.type === "Bag" ? BAG_DETAIL_VIEW : SHIPMENT_DETAIL_VIEW;
       if(state.pageFrom === "InComingLCReport" || state.pageFrom === "OutGoingLCReport" || state.pageFrom === "LCRTallyReport"){
        let dataArr = state.data;
        setTableData(dataArr);
        setPagination(prev => ({
          ...prev,
          total: dataArr.length,
          current: 1
        }));
       }else{
        let dataArr = state.data;
        setTableData(dataArr);
        setPagination(prev => ({
          ...prev,
          total: dataArr.length,
          current: 1
        }));
       }
       
      } catch (error) {
        message.config({ top: 80 });
        message.error("An error occurred while fetching details");
        setTableData([]);
        setPagination(prev => ({
          ...prev,
          total: 0,
          current: 1
        }));
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [state?.vehicle_lcr_id, state?.status, state?.type,state?.data]);

  // Download handler
  const handleDownload = async () => {
    if (!state?.vehicle_lcr_id || !state?.type || !state?.status) {
      message.error("Missing LCR number, type, or status for download");
      return;
    }
    console.log("state.pageFrom", state);
    setDownloadLoading(true);
    try {
     // console.log("hello........................"+state.vehicle_lcr_id+"          "+state?.pageFrom + "      " + state?.type + "       "+state.status);
      // Construct downloadParams similar to IncomingLCRReport
       if( state.pageFrom === "InComingLCReport" || state.pageFrom === "OutGoingLCReport" || state.pageFrom === "LCRTallyReport"){
        console.log(state?.pageFrom + "      " + state?.type + "");
        const downloadParams = {
          lcrNum: state.vehicle_lcr_id,
          type: state.status,
        };
        await downloadDetailedBagOrShipmentLCRReport(downloadParams);
        message.success("Detailed report downloaded successfully");
       }else{
        showErrorMessage("Failed to download detailed report");
       }

      
    } catch (error) {
      message.error("Failed to download detailed report");
    } finally {
      setDownloadLoading(false);
    }
  };

  const columns = [
    {
      title: state?.type !== "Bag" ? "AWB Number" : "Bag Number",
      dataIndex: state?.type !== "Bag" ? "awbNumber" : "bagNum",
      key: state?.type !== "Bag" ? "awbNumber" : "bagNum",
      sorter: (a, b) => {
        const aVal = a[state?.type !== "Bag" ? "awbNumber" : "bagNum"] || "";
        const bVal = b[state?.type !== "Bag" ? "awbNumber" : "bagNum"] || "";
        return aVal.localeCompare(bVal);
      },
      render: (text, record) => (
        <span
          style={{ color: "#2977ff", cursor: "pointer", textDecoration: "underline" }}
          onClick={() => {
            handleCellClick(text, record);
          }}
        >
          {text}
        </span>
      )
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => (a.status || "").localeCompare(b.status || ""),
    },
    {
      title: "Current Hub",
      dataIndex: "currentHub",
      key: "currentHub",
      sorter: (a, b) => (a.currentHub || "").localeCompare(b.currentHub || ""),
    },
    {
      title: "Source Hub",
      dataIndex: "sourceHub",
      key: "sourceHub",
      sorter: (a, b) => (a.sourceHub || "").localeCompare(b.sourceHub || ""),
    },
    {
      title: "Destination Hub",
      dataIndex: "destinationHub",
      key: "destinationHub",
      sorter: (a, b) => (a.destinationHub || "").localeCompare(b.destinationHub || ""),
    },
    {
      title: "Updated Date",
      dataIndex: "updatedDate",
      key: "updatedDate",
      sorter: (a, b) => {
        const aDate = new Date(a.updatedDate);
        const bDate = new Date(b.updatedDate);
        return aDate - bDate;
      },
      render: (text, record) => (
        <span>
          {text ? formateDate(text) : "-"}
        </span>
      )
    },
    ...(state?.type !== "Bag"
      ? [
        {
          title: "Destination Pincode",
          dataIndex: "destinationPincode",
          key: "destinationPincode",
          sorter: (a, b) => (a.destinationPincode || "").localeCompare(b.destinationPincode || ""),
        },
      ]
      : []),
  ];

  if (!state) {
    return (
      <div className="p-2-tab">
        <Heading title="Detailed Bag/Shipment In-Out" />
        <div className="detailed-view-container">
          <p>No data was provided to display the detailed view.</p>
        </div>
      </div>
    );
  }
  const formateDate = (date) => {
    return moment.utc(date).format("DD/MM/YYYY:HH:mm:ss");
  };
  const handleCellClick = async (type, record) => {
    const finalTrackingNumber = type;
    const url = `/shipment-tracker?awb=${encodeURIComponent(finalTrackingNumber)}`;
    window.open(url, "_blank");
  };
  
  const handleTableChange = (newPagination, filters, sorter) => {
    setPagination(prev => ({
        ...prev,
        current: newPagination.current,
        pageSize: newPagination.pageSize
    }));
  };

  // Get paginated data
  const getPaginatedData = () => {
    const startIndex = (pagination.current - 1) * pagination.pageSize;
    const endIndex = startIndex + pagination.pageSize;
    return tableData.slice(startIndex, endIndex);
  };

  return (
    <div className="p-2-tab">
      <Heading title={`${state.status ? ` ${state.status.toLowerCase().split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}` : ""} Detailed `} 
       navigateTo={state?.url}/>
      <div className="detailed-view-container">
        <div className="summary-section">
          <div className="summary-item">
            <span className="label">LCR Number:</span>
            <span className="value">{state?.vehicle_lcr_id}</span>
          </div>
          <div className="summary-item">
            <span className="label">Vehicle/Flight Number:</span>
            <span className="value">{state?.vehicle_num}</span>
          </div>
          <div className="summary-item" style={{ marginLeft: "auto" }}>
            { (state.pageFrom === "InComingLCReport" || state.pageFrom === "OutGoingLCReport" || state.pageFrom === "LCRTallyReport") && (
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                loading={downloadLoading}
                onClick={handleDownload}
              >
                Download Report
              </Button>
            )}
          </div>
        </div>

        <div className="tables-container">
          <div className="table-section">
            <Table
              columns={columns}
              dataSource={getPaginatedData()}
              loading={loading}
              pagination={pagination}
              scroll={{ x: 1200 }}
              onChange={handleTableChange}
              rowKey={(record) => record.awbNumber || record.bagNum || record.id || Math.random()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailedInOutView;
